export default __webpack_public_path__ + "static/media/logo_einstein_redondo_branco.dd41fb6f.svg";